import PortalIdParser from 'PortalIdParser';
export function handleDynamicListCreation(objectTypeId, filterBranch, customProperties) {
  const portalId = PortalIdParser.get();
  const urlSearchParams = new URLSearchParams();
  // encode custom properties
  const encodedCustomProperties = Object.keys(customProperties).reduce((acc, key) => {
    if (customProperties[key] == null) return acc;
    acc[key] = encodeURIComponent(customProperties[key]);
    return acc;
  }, {});
  urlSearchParams.append('objectTypeId', encodeURIComponent(objectTypeId || '0-1'));
  urlSearchParams.append('processingType', 'DYNAMIC');
  urlSearchParams.append('filterBranch', filterBranch);
  urlSearchParams.append('customProperties', JSON.stringify(encodedCustomProperties));
  window.open(`/contacts/${portalId}/objectLists/create?${urlSearchParams.toString()}`);
}